import React from "react";
import {Team} from "./Team";
import {Holes} from "./Holes";
import {cn} from "../lib/Utils";

export function MatchCard({
  match = {},
  matchIndex,
  teamColors = {},
  leftTeamId,
  rightTeamId,
  colors
}) {
    // We create a map of sides by teamId
    const sideMap = Object.values(match.sides || {}).reduce((acc, side) => {
        acc[side.teamId] = side;
        return acc;
    }, {});

    // We remove each side (or {} if it does not exist)
    const leftSide = sideMap[leftTeamId] || {};
    const rightSide = sideMap[rightTeamId] || {};

    // We normalize the list of players
    const norm = (s) =>
        s.players
            ? Array.isArray(s.players)
                ? s.players
                : [s.players]
            : [];

    const leftPlayers = norm(leftSide);
    const rightPlayers = norm(rightSide);

    // Win/Draw States
    const leftWon = leftSide.is_winner === true;
    const rightWon = rightSide.is_winner === true;
    const isDraw = Boolean(match.result) && !leftWon && !rightWon;

    // Fallback “TBD” for each side
    const tbdLeft = !leftSide.teamId;
    const tbdRight = !rightSide.teamId;

    // Here is the logic of holes
    const holes = match.resultsByHole
        ? Object.values(match.resultsByHole)
        : Array(18).fill(null);


    // We make sure to pass the IDs as numbers
    const leftIdNum = Number(leftTeamId);
    const rightIdNum = Number(rightTeamId);

    const matchDate = match.date
        ? new Date(match.date.date).toLocaleDateString("es-ES", {
            day: "2-digit",
            month: "2-digit",
            year: "2-digit",
        })
        : "";

    const matchHour = match.hour
        ? new Date(match.hour.date).toLocaleString("es-ES", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
        })
        : "";

    return (
        <div
            className={cn(
                "relative rounded-lg bg-white shadow-sm mb-2 overflow-hidden border-0",
                leftWon
                    ? `border-b-3 border-b-${colors[0]}-500`
                    : rightWon
                        ? `border-b-3 border-b-${colors[1]}-500`
                        : "border-b border-gray-200"
            )}
        >
            <div
                className="sm:hidden bg-gray-50 px-4 py-2 flex justify-end items-center text-xs sm:text-sm font-medium text-gray-700 border-b border-gray-300">
                <span className="text-xs sm:text-xs lg:text-base font-medium text-gray-700 date-style bg-gray-100 rounded-md px-2 py-1">
                        {matchDate}
                    </span>
                {matchHour && (
                    <span className="text-xs sm:text-xs lg:text-base font-medium text-gray-700 hour-style bg-blue-100 rounded-full px-2 py-1">
                            {matchHour}
                        </span>
                )}
            </div>


            <div className="flex flex-col sm:flex-row">
                <Team
                    players={leftPlayers}
                    teamColor={teamColors[leftIdNum]}
                    isWinner={leftWon}
                    isDraw={isDraw}
                    result={match.result}
                    match={match}
                    tbd={tbdLeft}
                />
                <Team
                    players={rightPlayers}
                    teamColor={teamColors[rightIdNum]}
                    isWinner={rightWon}
                    isDraw={isDraw}
                    result={match.result}
                    tbd={tbdRight}
                    match={match}
                    isRight={true}
                />
            </div>

            <Holes
                holes={holes}
                team1Id={leftIdNum}
                team2Id={rightIdNum}
                teamColors={teamColors}
                match={match}
            />
        </div>
    );
}
